<template>
    <div>
        <b-table
            show-empty
            empty-text="ไม่มีรายละเอียดข้อมูลอื่นๆ"
            :items="other"
            :fields="fieldsOther"
            responsive
            :busy="busy"
            class="scroll-bar-pop"
        >
            <div slot="table-busy" class="text-center">
                <BlockUI >
                    <div class="loader"></div>
                </BlockUI>
            </div>
            <template slot="shop_code" slot-scope="row">
                <span>{{row.item.shop_code}}</span><br>
                <span>{{row.item.owner_name}}</span><br>
                <span>{{($THEME.packagePrefix) ? $THEME.packagePrefix[row.item.package] : row.item.package}}</span>
            </template>
            <template slot="sell_service" slot-scope="row">
                <span class="text-newline">{{sellServiceBrance(row.item.sell_service)}}</span>
            </template>
            <template slot="other_service" slot-scope="row">
                <span class="text-newline">{{otherServiceBrance(row.item.other_service)}}</span>
            </template>
            <template slot="cctv" slot-scope="row">
                <i :class="['fas fa-check-circle fa-sm', {'text-success': (row.item.cctv == 'YES')} , {'text-danger': (row.item.cctv != 'YES')}]"></i>
            </template>
             <template slot="barcode_scanner" slot-scope="row">
                <i :class="['fas fa-check-circle fa-sm', {'text-success': (row.item.barcode_scanner == 'YES')} , {'text-danger': (row.item.barcode_scanner != 'YES')}]"></i>
            </template>
            <template slot="parking" slot-scope="row">
                <i :class="['fas fa-check-circle fa-sm', {'text-success': (row.item.parking == 'YES')} , {'text-danger': (row.item.parking != 'YES')}]"></i>
            </template>
            <template slot="operating_system" slot-scope="row">
                <template v-if="row.item.operating_system != '-'">
                    <div v-for="(system,index) in row.item.operating_system" :key="index">
                        <span v-if="typeof system === 'object' && system !== null">{{system.other}}</span>
                        <span v-else>{{operatingSystemBrance(system)}}</span>
                    </div>
                </template>
                <span v-else>-</span>
            </template>
            <template slot="pickup_thp" slot-scope="row">
                <i :class="['fas fa-check-circle fa-sm', {'text-success': (row.item.pickup_thp == 'YES')} , {'text-danger': (row.item.pickup_thp != 'YES')}]"></i>
            </template>
            <template slot="time_pickup_thp" slot-scope="row">
                <span>{{ (row.item.time_pickup_thp != '-') ? `${row.item.time_pickup_thp} น.` : '-' }} </span>
            </template>
            <template slot="nums_order_thp" slot-scope="row">
                <span>{{ (row.item.nums_order_thp > 0) ? `${row.item.nums_order_thp} ชิ้น` : '-' }} </span>
            </template>
            <template slot="type_car_thp" slot-scope="row">
                <span>{{typeCarTHPBrance(row.item.type_car_thp)}}</span>
            </template>
            <template slot="actions" slot-scope="row">
                <button
                    class="btn btn-sm btn-info px-3"
                    @click="$router.push({name:'branceedit',params:{Id:row.item.id}})"
                >แก้ไข</button>
                <button
                    class="btn btn-sm btn-danger px-3"
                    @click="($emit('showComfirmModal',row.item.id))"
                    v-if="auth0RoleUsage('brancemanagedelete')"
                >ลบ</button>
            </template>
        </b-table>
    </div>
</template>
<script>
import { sellServiceBrance , otherServiceBrance , operatingSystemBrance , typeCarTHPBrance } from "@/plugins/formatForBrance.js";
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
    name:"TableBranceOther",
    props: {
        busy: Boolean,
        other: Array,
    },
    data(){
        return  {
            sellServiceBrance: sellServiceBrance,
            otherServiceBrance: otherServiceBrance,
            operatingSystemBrance: operatingSystemBrance,
            typeCarTHPBrance: typeCarTHPBrance,
            auth0RoleUsage: auth0RoleUsage,
        }
    },
    computed:{
        fieldsOther(){
            let fields = [
                { key: "last_updated", label: "วันที่อัพเดตข้อมูลล่าสุด", sortable: true },
                { key: "shop_code", label: "ร้าน", sortable: true ,class: 'text-center'},
                { key: "sell_service", label: "สนใจเปิดบริการเสริมอื่นๆ หรือไม่", sortable: true },
                { key: "other_service", label: "สนใจหรือไม่ หากมีบริการเสริมใหม่เข้ามา", sortable: true },
                { key: "cctv", label: "กล้องวงจรปิด", sortable: true ,class: 'text-center'},
                { key: "barcode_scanner", label: "เครื่องสแกนบาร์โค้ด", sortable: true ,class: 'text-center'},
                { key: "parking", label: "ที่จอดรถ", sortable: true ,class: 'text-center'},
                { key: "operating_system", label: "ระบบปฏิบัติการโทรศัพท์หน้าร้าน", sortable: true },
                { key: "pickup_thp", label: "สนใจให้ไปรษณีย์ไทยเข้ารับพัสดุหรือไม่", sortable: true , class: 'text-center' },
                { key: "time_pickup_thp", label: "ไปรษณีย์ไทยเข้ารับพัสดุกี่โมง", sortable: true , class: 'text-center' },
                { key: "nums_order_thp", label: "จำนวนพัสดุที่ส่งกับไปรษณีย์ต่อวัน", sortable: true , class: 'text-center' },
                { key: "type_car_thp", label: "เลือกรถไปรษณีย์เข้ารับ", sortable: true , class: 'text-center'},
                { key: "actions", label: "การจัดการ", sortable: true }
            ]
            return fields
        },
    }
   
}
</script>